import type { StoreRouter } from "replo-publisher-v1/src/trpc/routers/store";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: storeRouter,
  client: storeClient,
  utils: storeUtils,
  options: storeOptions,
} = createTrpcRouterConfig<StoreRouter>({
  path: "store",
  queryClient: getNamespacedQueryClient("store"),
});

export { storeClient, storeRouter, storeUtils, storeOptions };
